import Component from 'vue-class-component'
import ConvoComponent from './ConvoComponent'
import ConvoView from './ConvoView.vue'
import convoStore from '@/store/convo/convo-store';
import feedStore from '@/store/feed/feed-store';
import LoadingIndicator from '@/components/LoadingIndicator'
import authStore from '@/store/auth/auth-store';
import LoginButton from '@/components/buttons/LoginButton';

@Component({
  name: 'convos',
  components: {
    'login-button': LoginButton,
    'loading-indicator': LoadingIndicator,
    'convo-view': ConvoView
  }
})
export default class Convos extends ConvoComponent {
  mounted (): void {
    console.log('Convos.ts: mounted')

    this.fetchConvos();

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'feed/setFeed') {
        this.fetchConvos()
      }

      if (mutation.type === 'feed/setUser') {
        this.fetchConvos()
      }
    })

    if (feedStore.feedUserId) {
      this.fetchConvos()
    }
  }

  get isAuthenticated():boolean {return authStore.isAuthenticated}

  get isLoading():boolean {return convoStore.isLoading}

  protected fetchConvos() {
    convoStore.dispatchInitFetchConvos()
  }
}
